import { Rocket } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Tooltip } from "@similarweb/ui-components";

import { getPackageHref } from "app/common/hrefs";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { headerDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { allTrackers } from "app/services/track/track";
import { isNoTouch, isSI } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

const explorePlansButtonStyle = {
    minWidth: 0,
    padding: 0,
    width: 40,
    height: 40,
    justifyContent: "center",
} as const;

export const ExplorePlansButton = () => {
    if (!isNoTouch(swSettings) || isSI(swSettings)) {
        return null;
    }

    const handleClick = (): void => {
        allTrackers.dispatchTrackEvent("Button", "click", "explore plans button");
        window.open(getPackageHref());
    };

    const handleHover = (): void => {
        allTrackers.dispatchTrackEvent("Button", "hover", "explore plans button");
    };

    return (
        <Tooltip
            content={translate("marketing.components.explore_plans_button.tooltip")}
            placement="bottom"
        >
            <Button
                type="flat"
                isNoLabel
                style={explorePlansButtonStyle}
                onClick={handleClick}
                onMouseEnter={handleHover}
                dataAutomation={headerDataAutomation.rocketIcon}
            >
                <Rocket
                    color={colorsPalettes.blue[400]}
                    size="sm"
                />
            </Button>
        </Tooltip>
    );
};
